var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "simulation-details", "data-cy": "component-simulation" } },
    [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("SimulationCard", {
              attrs: { "read-only": _vm.readOnlySimulation },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("PropertyCard", {
              attrs: { "is-open": "", "read-only": _vm.readOnlySimulation },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }